import { signInWithPopup, getAdditionalUserInfo } from "firebase/auth";
import {
  firebase_auth,
  firebase_auth_google,
} from "@src/utility_functions/database_operations/config/firebaseConfig";
import { fetchFirestoreUserObject } from "@src/utility_functions/database_operations/users/readUser/fetchFirestoreUserObject";
import { createUserGoogle } from "@src/utility_functions/database_operations/users/createUserGoogle";
import { sendRequestToServer } from "@src/utility_functions/database_operations/sendRequestToServer";

export const login_with_google = async () => {
  let returnValue = {};
  if (firebase_auth.currentUser) {
    returnValue = await fetchFirestoreUserObject(
      firebase_auth.currentUser?.uid,
    );
  } else {
    const userCredential = await signInWithPopup(
      firebase_auth,
      firebase_auth_google,
    );
    const isNewUser = await getAdditionalUserInfo(userCredential)?.isNewUser;
    if (isNewUser) {
      const serverResponse = await createUserGoogle(
        "/server/database_operations/users/createUserGoogle",
      );
      returnValue = serverResponse.userData;
    } else {
      // Capture/refresh provider images and AWAIT it so the write is committed
      // before we return: LoginForm invalidates the userDocument query right
      // after this resolves, and a fire-and-forget sync raced that refetch and
      // rendered stale (empty) provider data. The unchanged-photo path skips the
      // download, so the common case stays fast.
      const syncResponse = await sendRequestToServer(
        { payload: "payload" },
        "/server/database_operations/users/syncProviders",
      );
      returnValue =
        syncResponse?.userData ??
        (await fetchFirestoreUserObject(firebase_auth.currentUser?.uid));
    }
    localStorage.setItem("loginMethod", "google.com");
  }
  return returnValue;
};
